/**
 * MAGSDK basic implementation of access control plugin.
 *
 * @author Igor Zapororzhets <i.zapororzhets@infomir.com>
 */

'use strict';

var privateSettings = {
        password: '0000',
        sessionTime: 0,
        active: true
    },

    storageKey = 'parent.settings',

    isAllowedAccess = false,

    notification = null,

    instance;


function keyboardIntent ( config, callback ) {
    return core.intent({
        action: 'keyboard',
        data: {
            type: config.type,
            mode: config.mode,
            title: config.title,
            value: config.value
        },
        events: {
            done: callback
        }
    }, function ( error ) {
        console.log(error);
    });
}


instance  = {
    request: function ( password, callback ) {
        var isEqual = null,
            intent;

        password = password || null;

        if ( typeof password === 'function' ) {
            callback = password;
            password = null;
        }
        console.log(' password ' + password);

        if ( instance.settings.active ) {
            if ( isAllowedAccess ) {
                callback(false, true);
            } else if ( password === null ) {
                if ( notification !== null ) {
                    notification.close();
                    notification = null;
                }

                intent = keyboardIntent({
                    type: 'password',
                    mode: 'number',
                    title: gettext('Input password'),
                    description: gettext('Parental control')
                }, function ( event ) {
                    isEqual = event.value === instance.settings.password;
                    console.log('isEqual ' + isEqual);

                    if ( !isEqual ) {
                        notification = core.notify({
                            title: gettext('Wrong password for parental control'),
                            icon: 'alert',
                            type: 'warning',
                            timeout: 10000
                        });
                    }
                    callback(!isEqual, isEqual);
                });

                if ( intent.state === intent.STATE_NOT_RESOLVED ) {
                    callback(false, false);
                } else {
                    intent.once('close', function () {
                        if ( isEqual === null ) {
                            // not called yet
                            callback(true);
                        }
                    });
                }
            } else {
                isEqual = password === instance.settings.password;
                callback(!isEqual, isEqual);
            }
        } else {
            callback(false, true);
        }
    },

    settings: {
        update: function ( config, callback ) {
            var updateRequired = false;

            console.log(JSON.stringify(config));
            if ( typeof config.active !== 'undefined' && config.active !== privateSettings.isActive ) {
                updateRequired = true;
            }

            if ( typeof config.sessionTime !== 'undefined' && config.sessionTime !== privateSettings.sessionTime ) {
                if ( config.sessionTime === Number(config.sessionTime) ) {
                    updateRequired = true;
                }
            }

            if ( typeof config.password !== 'undefined' && config.password !== privateSettings.password ) {
                updateRequired = true;
            }

            console.log('updateRequired: ' + updateRequired);

            if ( updateRequired ) {
                instance.request(config.oldPassword, function ( error ) {
                    var passwordUpdateRequired = null;

                    console.log('request ' + error);

                    if ( !error ) {
                        if ( typeof config.active !== 'undefined' ) {
                            privateSettings.active = !!config.active;
                        }

                        if ( typeof config.sessionTime !== 'undefined' ) {
                            privateSettings.sessionTime = config.sessionTime;
                            isAllowedAccess = true;
                            setTimeout(function ()  {
                                isAllowedAccess = false;
                            }, privateSettings.sessionTime);
                        }

                        if ( typeof config.password !== 'undefined' ) {
                            passwordUpdateRequired = true;
                            privateSettings.password = '' + config.password;
                        }

                        if ( core.backend && core.backend.request ) {
                            if ( passwordUpdateRequired ) {
                                core.backend.request('users/' + core.backend.session.userId + '/settings', {
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded'
                                    },
                                    method: 'PUT',
                                    body: 'parent_password=' + privateSettings.password
                                });
                            }

                            core.backend.request('storage/', {
                                method: 'POST',
                                async: true,
                                body: JSON.stringify({key: storageKey, value: JSON.stringify(privateSettings)})
                            });
                        } else {
                            core.storage.setItem(storageKey, privateSettings);
                        }
                    }
                    callback(error);
                });
            }
        },
        updatePassword: function ( callback ) {
            if ( notification !== null ) {
                notification.close();
                notification = null;
            }

            keyboardIntent({
                type: 'password',
                mode: 'number',
                title: gettext('Enter current password'),
                description: gettext('Parental control')
            }, function ( event ) {
                var oldPassword = event.value;

                if ( oldPassword === privateSettings.password ) {
                    keyboardIntent({
                        type: 'password',
                        mode: 'number',
                        title: gettext('Enter new password'),
                        description: gettext('Parental control')
                    }, function ( result ) {
                        if ( result.value === privateSettings.password ) {
                            notification = core.notify({
                                title: gettext('The new password is the same as current one'),
                                icon: 'alert',
                                type: 'warning'
                            });
                        } else {
                            core.accessControl.settings.update({
                                oldPassword: oldPassword,
                                password: result.value
                            }, function ( error, updateResult ) {
                                if ( !error ) {
                                    notification = core.notify({
                                        title: gettext('Password changed successfully'),
                                        icon: 'info',
                                        type: 'success'
                                    });
                                }

                                callback(error, updateResult);
                            });
                        }
                    });
                } else {
                    notification = core.notify({
                        title: gettext('Wrong current password'),
                        icon: 'alert',
                        type: 'error'
                    });
                }
            });
        }
    }
};

function createDefaultSettings () {
    core.backend.request('storage/', {
        method: 'POST',
        body: JSON.stringify({key: storageKey, value: JSON.stringify(privateSettings)})
    });
}

Object.defineProperties(instance.settings, {
    password: {
        get: function () {
            return privateSettings.password;
        }
    },
    sessionTime: {
        get: function () {
            return privateSettings.sessionTime;
        }
    },
    active: {
        get: function () {
            return privateSettings.active;
        }
    }
});


Object.defineProperty(instance, 'state', {
    get: function () {
        return isAllowedAccess;
    }
});

if ( core.backend ) {
    privateSettings.password = core.backend.settings.parent_password;
    core.backend.request('storage/' + storageKey, {
        onload: function ( error, response ) {
            if ( error ) {
                createDefaultSettings();
            } else if ( response.data && response.data.value ) {
                try {
                    response.data.value = JSON.parse(response.data.value);
                    privateSettings.sessionTime = response.data.value.sessionTime;
                    privateSettings.active = response.data.value.active;
                } catch ( exceptionError ) {
                    console.log(exceptionError);
                    createDefaultSettings();
                }
            }
        }
    });
} else {
    (function () {
        var data = core.storage.getItem(storageKey);

        if ( data ) {
            privateSettings.password = data.password;
            privateSettings.active = !!data.active;
            privateSettings.sessionTime = parseInt(data.sessionTime, 10);
        }
    })();
}


module.exports = instance;
